module.exports = __webpack_public_path__ + "static/media/antigua-beaches-1.fd3f4571.jpg";